
import { getData, postData, putData } from "../apiClient";

const ItemName = "Room Status";
const API_URL = "room-status";


export const Search = async ({ date, floor, status, search }) => {
  try {
    const queryParams = new URLSearchParams({
      date: date,
      floor: floor,
      status: status,
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {});
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

export const getFloorlist = async () => {
  try {
    const result = await getData(`/${API_URL}/floor-list`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get user data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
}

export const RoomTimelineFilterSelect = async ({
  from = "",
  to = "",
  floor = "",
  roomType = "",
  status = "",
  search = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    if (floor) params.append("floor", floor);
    if (roomType) params.append("roomType", roomType);
    if (status) params.append("status", status);
    if (search) params.append("search", search);
    const qs = params.toString();

    const result = await getData(
      `/${API_URL}/room-timeline-filter-select${qs ? `?${qs}` : ""}`
    );
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get room timeline API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const CreateNotes = async (data) => {
  try {
    const result = await postData(`/${API_URL}`, data);
    return result;
  } catch (error) {
    throw error;
  }
};

// update item ** // Updated Api Error Handle Method
export const UpdateNotes = async (id, data) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data);
    return result;
  } catch (error) {
    throw error;
  }
};
